/*
 * @ Author: wangjiyu
 * @Date: 2020-04-10 11:54:38
 * @LastEditTime: 2020-04-10 13:45:59
 * @LastEditors: wangjiyu
 * @Description: file content
 */

import uploadDialog from './uploadDialog';

export default uploadDialog;
